import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { useEffect, useRef, useState } from "react";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import { ButtonsContainer } from "../move-inRegistrationTabs/move-inTabs.styled";
import { TabContainer, ThankyouHeader, ThankyouMessage } from "../SocialCaseTbas/Social.styled";
// import { InputContainer } from ".../../MoveOut.styled";
import cc from "../../assets/ccIcon.svg";
import { Label } from "../../screens/complaint/Complaint.styled";
import cvv from "../../assets/cvv.svg";
import CloseIcon from "../../assets/CloseIcon.svg";
import ThanksIcon from "../../assets/thanks.svg";
import styled from "styled-components";

import OtpInput from "react18-input-otp";

import General from "../../stores/GeneralStore";
import User from "../../stores/UserStore";
import { observer } from "mobx-react";
import { NotifyError } from "../../utils/ShowError";
import { Spinner } from "../SpinnerRaw/SpinnerRaw";
import { generateUUID, maskEmail, maskUaeMobile } from "../../../src/utils/utilityHelper";
import { OtpProtectedOperations } from "../../../src/utils/constants";

const InputContainer = styled.div<{ BackGround?: string }>`
  width: 40%;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
  input {
    height: 2.5rem;
    width: 2.5rem !important;
    background: ${props => props.BackGround ? props.BackGround : "#edf4f6"};
    border: 1px solid ${props => props.BackGround ? props.BackGround : "#b6bfdc"};
    margin: 0 0.5rem;
  }
`;

interface Obj {
  [key: string]: any;
}

interface Props extends BaseProps {
  setEnableMobilebleField: any;
  //   onVerify:any,
  onClose?: React.MouseEventHandler<HTMLImageElement | HTMLButtonElement>;

  email: string;
  mobile: string;
  personID: string;

}

const ProfileOTP = ({ mobile, email, personID, onClose }: Props) => {
  const transactionIdRef = useRef<string>(generateUUID());
  const [verified, setVerified] = useState<boolean>(false);
  const [screen, setScreen] = useState<number>(0);
  const [numbers, setNumbers] = useState("");

  const [otpDestination, setOtpDestination] = useState<number>(0);
  const newDestinationValueRef = useRef<HTMLInputElement | null>(null);
  const [newMobile, setNewMobile] = useState<any>();
  const handleChange = (otpConfirm: any) => {
    const regex = /^[0-9]+$/;

    if (otpConfirm.length < numbers.length) {
      // Backspace pressed
      setNumbers(otpConfirm);
    } else if (regex.test(otpConfirm)) {
      // Normal input
      setNumbers(otpConfirm);
    }
  };
  const deleteBankDetails = async () => {

    // deleteDetails(bankDetailData);
    const res = User?.deleteAccount({ errorId: 'updateBankDetailsError', data: {personId: personID, transactionId: transactionIdRef.current} })
    return res
  };
  const [verifyLoader, setverifyLoader] = useState(false);
  const handleVerification = async () => {
    const newVal = newDestinationValueRef.current?.value;
   setverifyLoader(true)
    const res = await General.verifyOTP({ errorId: "verifyOTPError", data: {
      numbers: numbers,
      transactionId: transactionIdRef.current
    }, });

    if (res?.result?.message == "Success") {
      const res = await deleteBankDetails();
      if (res?.result?.status == 200) {
        setNumbers('');
        setverifyLoader(false);
        setScreen(3);
      }
      console.log(res);
    }

    // if(onVerify)
    //   onVerify()
  };
  const handleLogoutClick = () => {
    User.logout();
    localStorage.removeItem("hash");
    localStorage.removeItem("nocType");
  };
  const handleMobileRadioButton = async (event: any) => {
    setOtpDestination(1);
  };

  const handleEmailRadioButton = async (event: any) => {
    setOtpDestination(2);
  };
const [sendOptloader, setSendOptloader] = useState(false)
  const handleSendOTP = () => {
    setSendOptloader(true)
    setNumbers("")
    const newVal = newDestinationValueRef.current?.value;
    setNewMobile(newVal);
    if (otpDestination == 1) {
      General.sendOTP({
        errorId: "sendOTPError",
        data: {
          premiseId: null,
          email: null,
          mobile: newVal ? newVal : mobile,
          personID,
          transactionId: transactionIdRef.current,
          operation: OtpProtectedOperations.DeleteAccount,
          // useProvidedContactInfo:false
        },
      });
      setSendOptloader(false)
      setScreen(1);
      
    } else if (otpDestination == 2) {
      General.sendOTP({
        errorId: "sendOTPError",
        data: {
          premiseId: null,
          email: newVal ? newVal : email,
          mobile: null,
          personID,
          transactionId: transactionIdRef.current,
          operation: OtpProtectedOperations.DeleteAccount,
          // useProvidedContactInfo:false
        },
      });
      setSendOptloader(false)
      setScreen(1);
    } else {
      setSendOptloader(false)
      NotifyError("Error: Please Select OTP Destination");
    }
  };

  //   useEffect(()=>{
  //     General.sendOTP({errorId: 'sendOTPError', data: {premiseId:null, email, mobile, personID}})
  //   },[])
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  return (
    <div style={{ minWidth: "45%", overflow: "auto", margin: "auto", direction: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "rtl" : "ltr", }}>
      <div
        style={{
          // height: '20%',
          width: "100%",
          justifyContent: "space-between",
          padding: "1rem",
          background: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss,
          display: "flex",
          alignItems: "center",
        }}
      >
        <h1
          style={{
            color: General?.contrast?.contrastBackground ? General?.contrast?.contrastBackground : "#fff",
            justifySelf: "flex-start",
            fontSize: `${2 * General.accessibility.fontSize}rem`,
          }}
        >
          {General?.codeLabels['cm_delete_account'].label ? General?.codeLabels['cm_delete_account'].label : "Delete Account"}
        </h1>
        {screen !== 3 && <img src={CloseIcon} alt="" onClick={onClose} />}
      </div>

      <TabContainer
        style={{
          padding: "12px 0px",
          display: "flex",
          gap: "0.5rem",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: General?.contrast?.contrastBackground ? General?.contrast?.contrastBackground : "#fff",
          color: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss,
        }}
      >
        {screen == 0 ? (
          <>
            <Typography
              component="p"
              sx={{
                fontWeight: "700",
                fontSize: `${1.5 * General.accessibility.fontSize}rem`,
                color: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss,
              }}
            >
              {General?.codeLabels["cm_where_otp"]?.label ? General?.codeLabels["cm_where_otp"]?.label : "Where can we send the OTP"}
            </Typography>



            <div style={{ display: "flex", flexDirection: "row", justifyContent: 'space-around', width: '100%' }}>
              <div style={{ display: "flex", alignItems: "baseline", gap: "5px" }}>
                <input
                  type={"radio"}
                  name={"otpDest"}
                  onClick={handleMobileRadioButton}
                />
                <p style={{ fontSize: `${General.accessibility.fontSize}rem`, color: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss }}>
                  {General?.codeLabels["cm_otp_mode_mobile"]?.label ? General?.codeLabels["cm_otp_mode_mobile"]?.label : "Send Otp To Registered Mobile Number"} <br /> {maskUaeMobile(mobile)}
                </p>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "baseline",
                  gap: "5px",
                  fontSize: `${General.accessibility.fontSize}rem`,
                }}
              >
                <input
                  type={"radio"}
                  name={"otpDest"}
                  onClick={handleEmailRadioButton}
                />
                <p style={{ fontSize: `${General.accessibility.fontSize}rem`, color: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss }}>
                  {General?.codeLabels["cm_otp_mode_email"]?.label ? General?.codeLabels["cm_otp_mode_email"]?.label : "Send Otp To Registered Email Id"} <br /> {maskEmail(email)}
                </p>
              </div>
            </div>

            <ButtonsContainer
              style={{ display: "flex", gap: "12px", width: "fit-content" }}
            >
              <ButtonSecondary
                style={{
                  width: "45%",
                  padding: "auto",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  borderColor: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss,
                  background: General?.contrast?.contrastBackground ? General?.contrast?.contrastBackground : "white",
                  color: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss,
                }}
                onClick={onClose}
              >
                {General?.codeLabels["cm_cancel"]?.label !== undefined
                  ? General?.codeLabels["cm_cancel"]?.label
                  : "CANCEL"}
              </ButtonSecondary>
              <ButtonSecondary
                style={{
                  width: "45%",
                  padding: "auto",
                  color: General?.contrast?.contrastBackground ? General?.contrast?.contrastBackground : "#fff",
                  background: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss,
                  whiteSpace: "nowrap",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  border: "none",

                }}
                onClick={handleSendOTP}
              >
                {sendOptloader?<Spinner width="30px" height="30px" /> : General?.codeLabels["cm_send_otp"]?.label !== undefined
                  ? General?.codeLabels["cm_send_otp"]?.label
                  : "SEND OTP"}
              </ButtonSecondary>
            </ButtonsContainer>
          </>
        ) : null}

        {screen === 1 ? (
          <>
            <Typography
              component="p"
              sx={{
                fontWeight: "700",
                fontSize: `${1.5 * General.accessibility.fontSize}rem`,
              }}
            >
              {General?.codeLabels["cm_otp_send"]?.label !== undefined ? General?.codeLabels["cm_otp_send"]?.label : "Please enter the one-time password"}
            </Typography>
            <p
              style={{
                width: "60%",
                textAlign: "center",
                fontSize: `${General.accessibility.fontSize}rem`,
                color: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss,
              }}
            >
              {otpDestination == 1 ? `${General?.codeLabels["cm_otp_mode_mobile"]?.label !== undefined ? General?.codeLabels["cm_otp_mode_mobile"]?.label : "Send Otp To Registered Mobile Number"} ${newMobile ? maskUaeMobile(newMobile) : maskUaeMobile(mobile)}` : `${General?.codeLabels["cm_otp_mode_email"]?.label !== undefined ? General?.codeLabels["cm_otp_mode_email"]?.label : "Send Otp To Registered Email ID"} ${newMobile ? newMobile : email}`}
            </p>

            <InputContainer
              BackGround={contrast?.contrastColor ? contrast?.contrastColor : ""}
              style={{ justifyContent: "center", direction: 'ltr' }}>
              <OtpInput value={numbers} onChange={handleChange} numInputs={6} isInputNum={true} />
            </InputContainer>

            <p
              style={{
                width: "70%",
                textAlign: "center",
                fontSize: `${General.accessibility.fontSize}rem`,
                marginTop: '0.5rem',
                color: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss,
              }}
            >
              {otpDestination == 2 ? General?.codeLabels["cm_em_otp2min"]?.label !== undefined ? General?.codeLabels["cm_em_otp2min"]?.label : "If you do not receive email OTP within 5 minutes" : General?.codeLabels["cm_mob_otp2min"]?.label !== undefined ? General?.codeLabels["cm_mob_otp2min"]?.label : "If you do not receive mobile OTP within 5 minutes"}{" "} &nbsp;
              <span
                style={{
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  fontWeight: '700',
                  color: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss,
                }}
                onClick={handleSendOTP}
              >
                {General?.codeLabels["cm_mob_resendotp"]?.label !== undefined
                  ? General?.codeLabels["cm_mob_resendotp"]?.label
                  : "Resend OTP"}{" "}
              </span>
            </p>
            <ButtonsContainer
              style={{ display: "flex", gap: "12px", width: "fit-content" }}
            >
              <ButtonSecondary
                style={{
                  width: "45%",
                  padding: "auto",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor ? contrast?.contrastColor : General?.ColorAss,
                  background: contrast?.contrastBackground ? contrast?.contrastBackground : "",
                  borderColor: contrast?.contrastColor ? contrast?.contrastColor : General?.ColorAss,
                }}
                onClick={() => setScreen(0)}
              >
                {General?.codeLabels["cm_backbutton"]?.label !== undefined
                  ? General?.codeLabels["cm_backbutton"]?.label
                  : "BACK"}
              </ButtonSecondary>
              <ButtonSecondary
                style={{
                  width: "100%",
                  padding: "auto",
                  color: contrast?.contrastBackground ? contrast?.contrastBackground : "white",
                  background: contrast?.contrastColor ? contrast?.contrastColor : General?.ColorAss,
                  fontSize: `${General.accessibility.fontSize}rem`,
                  border: "none"
                }}
                onClick={handleVerification}
              >
                {verifyLoader?<Spinner width="30px" height="30px" /> : General?.codeLabels["cm_ver_del"]?.label !== undefined ? General?.codeLabels["cm_ver_del"]?.label : "VERIFY & DELETE"}
              </ButtonSecondary>
            </ButtonsContainer>
          </>
        ) : null}



        {screen === 3 ? (
          <>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                alignSelf: "flex-start",
                marginTop: "5px",

              }}
            >
              <ThankyouMessage>
                <p
                  style={{
                    padding: "0",
                    margin: "0",
                    marginTop: "20px",
                    marginBottom: "20px",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    fontWeight: "700",
                    color: contrast?.contrastColor ? contrast?.contrastColor : General?.ColorAss
                  }}>
                  {General?.codeLabels["cm_delete_requestreq"].label ? General?.codeLabels["cm_delete_requestreq"].label : "Your request to delete your account has been successfully sent to Ajman Sewerage."}
                </p>


                <ButtonSecondary onClick={handleLogoutClick}
                  style={{ height: "50px", width: "252px", fontFamily: "Segoe UI", fontWeight: "700", fontSize: `${General.accessibility.fontSize}rem`, lineHeight: "130%", color: contrast?.contrastBackground ? contrast?.contrastBackground : "#fff", background: contrast?.contrastColor ? contrast?.contrastColor : General?.ColorAss, border: "none" }}>
                  {General?.codeLabels["cm_logout"]?.label !== undefined ? General?.codeLabels["cm_logout"]?.label : "log out"}
                </ButtonSecondary>
              </ThankyouMessage>
            </div>
          </>
        ) : null}


      </TabContainer>
    </div>
  );
};

export default observer(ProfileOTP);
